module.exports = __webpack_public_path__ + "static/media/bg-8.523cc43a.png";